<template>
  <div class="main">
    <Nav />
    <div class="loginForm" v-if="showLoginForm">
      <div class="loginForm-box">
        <img
          src="../images/close-icon.svg"
          alt=""
          @click="handleShowLoginForm"
          class="loginForm-close"
        />
        <p class="title">手机号快捷登录参与活动</p>
        <p class="desc">使用手机号快捷登录，无账号将自动注册</p>
        <input
          type="text"
          class="phone-number"
          placeholder="输入手机号码"
          v-model="phoneNumber"
        />
        <p class="veriPhone" v-show="showPhoneTip">{{ this.veriPhone }}</p>
        <div class="img-code-box">
          <input
            type="text"
            placeholder="输入图形验证码"
            class="imgCodeIpt"
            v-model="imgCodeNumber"
          />
          <img
            src="/ucenter/api/authimage"
            id="img-code"
            @click="changeImgCode"
          />
        </div>
        <p class="veriImg" v-show="showImgTip">{{ this.veriImg }}</p>
        <div class="veri-code-box">
          <input
            type="text"
            class="veri-code"
            placeholder="输入手机验证码"
            v-model="codeNumber"
            maxlength="6"
          />
          <button v-if="!isCounting" class="veri-btn" @click="sendCode">
            {{ this.veriBtn }}
          </button>
          <button v-if="isCounting" class="veri-btn-counting">
            {{ this.veriBtn }}
          </button>
        </div>
        <p class="veriCode" v-show="showCodeTip">{{ this.veriCode }}</p>
        <button class="login-btn" data-agl-cvt="5" @click="handleLogin">注册登录</button>
        <a
          href="javascript:void(0);"
          class="user-login"
          @click="handleUserLoginShow"
          >账号密码登录</a
        >
      </div>
    </div>
    <div class="loginForm" id="userLoginForm" v-if="showUserLoginForm">
      <div class="loginForm-box">
        <img
          src="../images/close-icon.svg"
          alt=""
          @click="handleShowUserLoginForm"
          class="loginForm-close"
        />
        <p class="title">账号密码登录参与活动</p>
        <p class="desc">使用虹软视觉开放平台账号登录</p>
        <input
          type="text"
          class="user-number"
          placeholder="输入账号"
          v-model="userNumber"
        />
        <p class="veriUser" v-show="showUserTip">{{ this.veriUser }}</p>
        <input
          type="password"
          class="pwd-number"
          placeholder="输入密码"
          v-model="pwdNumber"
        />
        <p class="veriPwd" v-show="showPwdTip">{{ this.veriPwd }}</p>
        <button class="login-btn" @click="handleUserLogin">登录</button>
        <a
          href="javascript:void(0);"
          class="user-login"
          @click="handlePhoneLoginShow"
          >手机号快捷登录</a
        >
      </div>
    </div>
    <div class="inviteFriendAlert" v-if="showInviteTips">
      <div class="inviteFriendAlert-box">
        <p>您的邀请链接已复制成功</p>
        <p>粘贴即可发送给好友</p>
      </div>
    </div>
    <div class="banner">
      <img src="../images/banner.png" alt="" />
    </div>
    <div class="banner-mobile">
      <img src="../images/banner-mobile.jpg" alt="" />
    </div>
    <div class="wrapper">
      <img class="bg1" src="../images/bg1.png" alt="" />
      <img class="bg2" src="../images/bg2.png" alt="" />
      <img class="bg3" src="../images/bg3.png" alt="" />
      <img class="bg4" src="../images/bg4.png" alt="" />
      <img class="bg5" src="../images/bg5.png" alt="" />
      <img class="ball1" src="../images/ball1.png" alt="" />
      <img class="ball2" src="../images/ball1.png" alt="" />
      <div class="invite-task">
        <img src="../images/title1.png" alt="" />
        <div>
          <p>
            完成以下其中一项任务，您即可免费获取1个增值版人脸识别SDK（ArcFace
            Pro）激活码（Android平台，可永久商用，
            <a class="jump" data-to="advantage" onclick="gtag('event', '了解增值版', {'event_category' : '邀友活动', 'event_label' : 'click1'});">了解增值版</a> ）
          </p>
          <p>1.成功邀请6位业内好友完成虹软视觉开放平台注册</p>
          <p>2.成功邀请3位业内好友进行虹软视觉开放平台注册并完成激活</p>
        </div>
      </div>
      <div class="invite-friend">
        <div class="invite-friend-title">
          <p>{{ this.status }}</p>
        </div>
        <div class="invite-friend-box">
          <div
            v-for="(item, index) in addList"
            :key="index"
            class="invite-friend-items"
          >
            <img
              class="invite-friend-img"
              :data-clipboard-text="sign"
              :src="item.imgUrl"
              alt=""
              @click="handleImgInvite(index)"
              :style="imgStyle"
              ref="default"
            />
            <p class="invite-friend-phone">{{ item.ph }}</p>
          </div>
        </div>
        <div class="invite-friend-line">
          <img src="../images/line.png" alt="" />
          <div class="invite-tip-1" v-if="!codeFlag1">
            <p>邀满3人注册且激活</p>
            <p>获赠1个激活码</p>
          </div>
          <div class="invite-tip-2" v-if="!codeFlag2">
            <p>邀满6人注册</p>
            <p>获赠1个激活码</p>
          </div>
          <div class="invite-sucess-tip-1" v-if="codeFlag1">
            <p>成功获赠1个激活码</p>
          </div>
          <div class="invite-sucess-tip-2" v-if="codeFlag2">
            <p>成功获赠1个激活码</p>
          </div>
        </div>
        <div
          class="invite-friend-btn"
          @click="handleInvite"
          :data-clipboard-text="sign"
        >
          <p>邀请好友 免费领码</p>
        </div>
        <a
          class="activate-method"
          href="https://ai.arcsoft.com.cn/manual/docs#/220"
          target="_blank"
          onclick="gtag('event', '好友如何激活', {'event_category' : '邀友活动', 'event_label' : 'click1'});"
          >好友如何激活？</a
        >
      </div>
      <div class="three-steps">
        <img class="title3" src="../images/title3.png" alt="" />
        <div class="three-steps-content">
          <div class="three-steps-item">
            <img src="../images/icon1.png" alt="" />
            <p>点击按键</p>
            <p>复制链接后分享给业内好友</p>
          </div>
          <div class="three-steps-item">
            <img src="../images/icon2.png" alt="" />
            <p>好友通过邀请</p>
            <p>成功注册或注册激活</p>
          </div>
          <div class="three-steps-item">
            <img src="../images/icon3.png" alt="" />
            <p>完成邀友任务</p>
            <p>即可获赠增值版激活码</p>
          </div>
        </div>
      </div>
      <div class="activity-question">
        <img src="../images/qrcode.png" alt="" />
        <div class="right-content">
          <p>活动规则及增值版使用有疑问？ 扫码添加官方虹助手</p>
          <div>
            <ul>
              <li>
                <img src="../images/qr1.png" alt="" />
                <p>增值版激活码点对点发放</p>
              </li>
              <li>
                <img src="../images/qr2.png" alt="" />
                <p>增值版激活码使用问题答疑</p>
              </li>
              <li>
                <img src="../images/qr3.png" alt="" />
                <p>参与社群抽奖、行业干货分享</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="advantage">
        <img src="../images/title4.png" alt="" />
        <a
          href="https://ai.arcsoft.com.cn/product/arcface_pro.html"
          target="_blank"
          onclick="gtag('event', '了解更多增值版相关', {'event_category' : '邀友活动', 'event_label' : 'click1'});"
          >了解更多增值版相关</a
        >
        <img src="../images/compare.png" alt="" class="compare" />
        <p>
          活动所赠增值版人脸识别SDK适用于Android平台（不可用于APP场景）， 支持
          Android 4.4+(arm v7、arm v8)
        </p>
      </div>
      <div class="activity">
        <p class="activity-heading">活动细则</p>
        <div class="rule first">
          <img src="../images/rule1.png" alt="" />
          <p class="title">活动时间</p>
          <p>活动截止到2025年12月31日</p>
        </div>
        <div class="rule second">
          <img src="../images/rule2.png" alt="" />
          <p class="title">参与人群</p>
          <p>平台内所有用户</p>
        </div>
        <div class="rule third">
          <img src="../images/rule3.png" alt="" />
          <p class="title">活动内容</p>
        </div>
        <div class="content">
          <p class="content-title"><span>1. </span>增值版激活码免费送</p>
          <p>
            活动期间，用户完成以下其中一项任务，
            即可免费获取1个增值版人脸识别SDK（ArcFace Pro）激活码：
          </p>
          <p>1）成功邀请6位业内好友完成虹软视觉开放平台注册；</p>
          <p>2）成功邀请3位业内好友注册并完成激活使用；</p>
          <p>
            如用户同时完成以上2项任务，则可获取2个增值版人脸识别SDK（ArcFace
            Pro）激活码。
          </p>
          <p class="content-title"><span>2. </span>行业交流，社群抽奖</p>
          <p>
            活动期间，新老用户添加官方虹助手、加入行业交流群，即可与行业开发者用户交流使用经验与心得；参与社群内抽奖活动，
            奖品为实物奖品（价值80元），中奖后分享至朋友圈，并截图联系虹助手领取。
          </p>
        </div>
        <div class="rule fourth">
          <img src="../images/rule4.png" alt="" />
          <p class="title">激活码及实物奖品发送</p>
        </div>
        <div class="deliver">
          <p class="deliver-title">
            <span>1. </span>本期活动中，每位邀请用户最多可获取2个激活码奖励；
          </p>
          <p class="deliver-title">
            <span>2. </span
            >用户获得激活码后请截图发送至虹助手，平台将通过虹助手发放激活码及相关文档；
          </p>
          <p class="deliver-title">
            <span>3. </span
            >因奖品有限，在社群抽奖活动中，用户仅限获得1次奖品，即用户中奖后将无法重复参与抽奖活动；
            针对获得实物奖品的用户，虹助手将及时联系并核实寄送地址。
          </p>
        </div>
        <div class="rule fifth">
          <img src="../images/rule5.png" alt="" />
          <p class="title">激活码使用</p>
        </div>
        <div class="deliver">
          <p class="deliver-title">
            <span>1. </span>用户在激活使用时须完成企业认证；
          </p>
          <p class="deliver-title">
            <span>2. </span
            >所获激活码可用于Android平台（不适用于APP场景），一个激活码仅用于一台设备，若该设备重置，激活码仍然生效；
          </p>
          <p class="deliver-title use">
            <span>3. </span>所获的增值版人脸识别SDK（ArcFace
            Pro）激活码可离线激活、离线使用，且永久装机授权；
          </p>
          <p class="deliver-title use">
            <span>4. </span
            >如有任何使用问题，可联系官方虹助手或提交工单，我们将及时为您解答。
          </p>
        </div>
        <div class="tips">
          <p class="tips-title">注意事项</p>
          <p>
            1.
            对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖的用户，
            虹软视觉开放平台有权取消其获奖资格或其因参加活动所获权益；
          </p>
          <p>2. 虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。</p>
        </div>
      </div>
    </div>
    <div class="wrapper-mobile">
      <div class="invite-task">
        <img src="../images/title1.png" alt="" />
        <div>
          <p>完成以下其中一项任务，您即可免费获取1个</p>
          <p>增值版人脸识别SDK（ArcFace Pro）激活码</p>
          <p>
            （Android平台，可永久商用，
            <a class="jump" data-to="advantage" onclick="gtag('event', '了解增值版', {'event_category' : '邀友活动', 'event_label' : 'click1'});">了解增值版</a>）
          </p>
          <p>1.成功邀请6位业内好友完成虹软视觉开放平台注册</p>
          <p>2.成功邀请3位业内好友进行虹软视觉开放平台注册并完成激活</p>
        </div>
      </div>
      <div class="invite-friend">
        <div class="invite-friend-title">
          <p>{{ this.status }}</p>
        </div>
        <div class="invite-friend-box">
          <img src="../images/mobile/line.png" alt="" />
          <div class="invite-tip-1" v-if="!codeFlag1">
            <p>邀满3人注册且激活</p>
            <p>获赠1个激活码</p>
          </div>
          <div class="invite-tip-2" v-if="!codeFlag2">
            <p>邀满6人注册</p>
            <p>获赠1个激活码</p>
          </div>
          <div class="invite-sucess-tip-1" v-if="codeFlag1">
            <p>成功获赠1个激活码</p>
          </div>
          <div class="invite-sucess-tip-2" v-if="codeFlag2">
            <p>成功获赠1个激活码</p>
          </div>
          <div class="invite-friend-list">
            <div
              v-for="(item, index) in addList"
              :key="index"
              class="invite-friend-items"
            >
              <img
                class="invite-friend-img"
                :data-clipboard-text="sign"
                :src="item.imgUrl"
                alt=""
                @click="handleImgInvite(index)"
                :style="imgStyle"
                ref="default"
              />
              <p class="invite-friend-phone">{{ item.ph }}</p>
            </div>
          </div>
        </div>
        <div class="invite-friend-btn">
          <p @click="handleInvite" :data-clipboard-text="sign">
            邀请好友 免费领码
          </p>
        </div>
        <a href="https://ai.arcsoft.com.cn/manual/docs#/220" target="_blank"
           onclick="gtag('event', '好友如何激活', {'event_category' : '邀友活动', 'event_label' : 'click1'});"
          >好友如何激活？</a
        >
      </div>
      <div class="three-steps">
        <img src="../images/mobile/title2.png" alt="" />
        <div class="three-steps-content">
          <ul>
            <li>
              <img src="../images/mobile/icon1.png" alt="" />
              <p>点击按键复制链接后分享给业内好友</p>
            </li>
            <li>
              <img src="../images/mobile/icon2.png" alt="" />
              <p>好友通过邀请成功注册或注册激活</p>
            </li>
            <li>
              <img src="../images/mobile/icon3.png" alt="" />
              <p>完成邀友任务即可获赠增值版激活码</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="activity-question">
        <div class="title">
          <p>活动规则及增值版使用有疑问？扫码添加官方虹助手</p>
          <img src="../images/qrcode.png" alt="" />
        </div>
        <ul>
          <li>
            <img src="../images/mobile/qr1.png" alt="" />
            <p>增值版激活码点对点发放</p>
          </li>
          <li>
            <img src="../images/mobile/qr1.png" alt="" />
            <p>增值版激活码使用问题答疑</p>
          </li>
          <li>
            <img src="../images/mobile/qr1.png" alt="" />
            <p>参与社群抽奖、行业干货分享</p>
          </li>
        </ul>
      </div>
      <div class="advantage">
        <img src="../images/mobile/title3.png" alt="" />
        <div class="compare"></div>
        <div>
          <p>活动所赠增值版人脸识别SDK适用于</p>
          <p>Android平台（不可用于APP场景），</p>
          <p>支持 Android 4.4+(arm v7、arm v8)</p>
        </div>
      </div>
      <div class="activity">
        <p class="activity-heading">活动细则</p>
        <div class="rule first">
          <img src="../images/rule1.png" alt="" />
          <p class="title">活动时间</p>
        </div>
        <p>活动截止到2025年12月31日</p>
        <div class="rule second">
          <img src="../images/rule2.png" alt="" />
          <p class="title">参与人群</p>
        </div>
        <p>平台内所有用户</p>
        <div class="rule third">
          <img src="../images/rule3.png" alt="" />
          <p class="title">活动内容</p>
        </div>
        <div class="content">
          <p class="content-title"><span>1. </span>增值版激活码免费送</p>
          <p>
            活动期间，用户完成以下其中一项任务，
            即可免费获取1个增值版人脸识别SDK（ArcFace Pro）激活码：
          </p>
          <p>1）成功邀请6位业内好友完成虹软视觉开放平台注册；</p>
          <p>2）成功邀请3位业内好友注册并完成激活使用；</p>
          <p>
            如用户同时完成以上2项任务，则可获取2个增值版人脸识别SDK（ArcFace
            Pro）激活码。
          </p>
          <p class="content-title second"><span>2. </span>行业交流，社群抽奖</p>
          <p>
            活动期间，新老用户添加官方虹助手、加入行业交流群，即可与行业开发者用户交流使用经验与心得；参与社群内抽奖活动，
            奖品为实物奖品（价值80元），中奖后分享至朋友圈，并截图联系虹助手领取。
          </p>
        </div>
        <div class="rule fourth">
          <img src="../images/rule4.png" alt="" />
          <p class="title">激活码及实物奖品发送</p>
        </div>
        <div class="deliver">
          <p class="deliver-title">
            <span>1. </span>本期活动中，每位邀请用户最多可获取2个激活码奖励；
          </p>
          <p class="deliver-title">
            <span>2. </span
            >用户获得激活码后请截图发送至虹助手，平台将通过虹助手发放激活码及相关文档；
          </p>
          <p class="deliver-title">
            <span>3. </span
            >因奖品有限，在社群抽奖活动中，用户仅限获得1次奖品，即用户中奖后将无法重复参与抽奖活动；
            针对获得实物奖品的用户，虹助手将及时联系并核实寄送地址。
          </p>
        </div>
        <div class="rule fifth">
          <img src="../images/rule5.png" alt="" />
          <p class="title">激活码使用</p>
        </div>
        <div class="deliver">
          <p class="deliver-title">
            <span>1. </span>用户在激活使用时须完成企业认证；
          </p>
          <p class="deliver-title md">
            <span>2. </span
            >所获激活码可用于Android平台（不适用于APP场景），一个激活码仅用于一台设备，若该设备重置，激活码仍然生效；
          </p>
          <p class="deliver-title use">
            <span>3. </span>所获的增值版人脸识别SDK（ArcFace
            Pro）激活码可离线激活、离线使用，且永久装机授权；
          </p>
          <p class="deliver-title use">
            <span>4. </span
            >如有任何使用问题，可联系官方虹助手或提交工单，我们将及时为您解答。
          </p>
        </div>
        <div class="tips">
          <p class="tips-title">注意事项</p>
          <p>
            1.
            对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖的用户，
            虹软视觉开放平台有权取消其获奖资格或其因参加活动所获权益；
          </p>
          <p>2. 虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。</p>
          <p></p>
        </div>
      </div>
    </div>
    <div id="invite-mobile-btn-wrap" v-if="isBtnShow">
      <button
        id="invite-mobile-btn"
        class="invite-friend-btn"
        @click="handleInvite"
        :data-clipboard-text="sign"
      >
        邀请好友 免费领码
      </button>
    </div>
    <div class="backTop" @click="backTop" v-show="isBackTopShow">^Top</div>
  </div>
</template>

<script>
import $ from "jquery";
import Clipboard from "clipboard";
import Nav from "../components/nav.vue";
import { post } from "../utils/request";
export default {
  name: "Home",
  components: { Nav },
  data() {
    return {
      isBtnShow: false,
      isBackTopShow: false,
      sign: "",
      codeFlag1: false,
      codeFlag2: false,
      status: "您有2个激活码待领取",
      showLoginForm: false,
      showUserLoginForm: false,
      isLogined: false,
      veriPhone: "",
      veriCode: "",
      veriImg: "",
      phoneNumber: "",
      codeNumber: "",
      imgCodeNumber: "",
      showCodeTip: false,
      showPhoneTip: false,
      showInviteTips: false,
      showImgTip: false,
      veriBtn: "获取短信验证码",
      isCounting: false,
      isImgCodeTrue: false,
      userNumber: "",
      showUserTip: false,
      veriUser: "",
      pwdNumber: "",
      showPwdTip: false,
      veriPwd: "",
      addList: [
        {
          imgUrl: require("../images/no-user.png"),
          ph: "",
        },
        {
          imgUrl: require("../images/no-user.png"),
          ph: "",
        },
        {
          imgUrl: require("../images/no-user-full.png"),
          ph: "",
        },
        {
          imgUrl: require("../images/no-user.png"),
          ph: "",
        },
        {
          imgUrl: require("../images/no-user.png"),
          ph: "",
        },
        {
          imgUrl: require("../images/no-user-full.png"),
          ph: "",
        },
      ],
      imgStyle: "cursor:pointer;",
    };
  },
  created() {
    this.checkStatus();
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    if (document.location.href.indexOf("ai.arcsoft.com.cn") > 0) {
      gtag("config", "UA-7959274-33");
    } else {
      gtag("config", "UA-7959274-34");
    }
    /* 监听窗口宽度 */
    const that = this;
    window.onresize = () => {
      return (() => {
        that.screenWidth = document.body.clientWidth;
      })();
    };
    window.addEventListener("scroll", this.handleScroll);
    $(".jump").on("click", function (e) {
      var target = e.target;
      var cls = $(target).data("to");
      if (document.documentElement.clientWidth <= 750) {
        $("html,body").scrollTop($("." + cls).offset().top + 2270);
      } else {
        $("html,body").scrollTop($("." + cls).offset().top - 96);
      }
    });
  },
  methods: {
    handleShowUserLoginForm() {
      this.showUserLoginForm = false;
    },
    handleScroll(e) {
      // console.log(
      //   "e.srcElement.scrollingElement.scrollTop",
      //   e.srcElement.scrollingElement.scrollTop
      // );
      if (e.srcElement.scrollingElement.scrollTop >= 400) {
        this.isBackTopShow = true;
      } else {
        this.isBackTopShow = false;
      }
      if (e.srcElement.scrollingElement.scrollTop <= 690) this.isBtnShow = true;
      else if (
        e.srcElement.scrollingElement.scrollTop >= 1345 &&
        this.showLoginForm == false
      ) {
        this.isBtnShow = true;
      } else {
        this.isBtnShow = false;
      }
    },
    backTop() {
      const timer = setInterval(() => {
        document.documentElement.scrollTop -= 100;
        if (document.documentElement.scrollTop == 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    /* 判断用户是否登录 */
    async checkStatus() {
      await post("/ucenter/user/checkStatus").then((res) => {
        if (res.data.retMsg.indexOf("已登录") > -1) {
          this.isLogined = true;
          this.getSignId();
          this.getUserFriend();
        }
      });
    },
    /* 获取助力过当前用户的好友列表 */
    async getUserFriend() {
      await post("/ucenter/activity/getSignAndExtensionActiveInfo", {
        tag: 202107,
      }).then((res) => {
        let friendObject = res.data.retObj.phoneAndActiveMap;
        // let friendObject = {
        //   "152****6666": false,
        //   // "152****2222": false,
        //   // "152****5555": false,
        //   // "152****7777": false,
        //   "152****3333": false,
        //   // "152****8888": true,
        //   "152****1111": true,
        //   "152****9999": true,
        // };
        const friendMap = new Map(Object.entries(friendObject));
        // console.log("-----------friendMap value", friendMap.values());
        let flag1 = 0;
        let flag2 = 0;
        for (let value of friendMap.values()) {
          if (value) {
            flag1++;
            flag2++;
          } else {
            flag2++;
          }
        }
        this.status =
          flag1 >= 3 || flag2 >= 6 ? "您已获得1个增值版激活码" : " ";
        if (flag1 < 3 && flag2 < 6) {
          this.status = "您有2个激活码待领取";
        }
        if (flag1 >= 3 || flag2 >= 6) {
          this.status = "您已获得1个增值版激活码";
        }
        if (flag1 >= 3 && flag2 >= 6) {
          this.status = "恭喜！您已成功获得2个增值版激活码";
        }
        this.codeFlag1 = flag1 >= 3 ? true : false;
        this.codeFlag2 = flag2 >= 6 ? true : false;
        const finalFriendMap = new Map(
          [...friendMap].filter(([k, v]) => v == true)
        );
        const falseMap = new Map([...friendMap].filter(([k, v]) => v == false));
        falseMap.forEach(function (value, key) {
          finalFriendMap.set(key, value);
        });
        friendObject = [...finalFriendMap.entries()].reduce(
          (friendObject, [key, value]) => (
            (friendObject[key] = value), friendObject
          ),
          {}
        );
        let friendList = Object.keys(friendObject);
        this.friendCount = this.friendCount - friendList.length;
        if (friendList.length >= 6) {
          this.isFriendFull = true;
        }

        for (var i = 0; i < this.addList.length; i++) {
          for (var j = 0; j < friendList.length; j++) {
            if (i == j) {
              //将friendList的第一个赋值给addList的第一个，依次类推
              this.addList[i].imgUrl = require("../images/unactive-user.png");
              this.addList[i].ph = friendList[j];
              if (friendObject[friendList[j]]) {
                this.inviteFriendTips = "1位好友激活，您已获得惊喜福袋";
                this.addList[i].imgUrl = require("../images/active-user.png");
              }
            }
          }
        }
      });
    },
    /* 获取用户UUID */
    async getSignId() {
      await post("/ucenter/activity/getSign", { tag: 202107 }).then((res) => {
        this.sign = `https://ai.arcsoft.com.cn/operator/resource/2021/regular/index.html#/invite?sign=${res.data.retMsg}`; //正式
        // this.sign = `http://172.17.10.103/operator/resource/2021/regular/index.html#/invite?sign=${res.data.retMsg}`; //测试
        // this.sign = `http://172.17.186.168:8080/#/invite?sign=${res.data.retMsg}`;  //本地
      });
    },
    /* 切换验证码 */
    changeImgCode() {
      $("#img-code").attr("src", "/ucenter/api/authimage?" + Math.random());
    },
    /* 短信验证码登录 */
    async handleLogin() {
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
      }
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      }
      if (this.codeNumber == "" || this.codeNumber == null) {
        this.veriCode = "请输入验证码";
        this.showCodeTip = true;
      }
      if (this.phoneNumber && !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      }
      /* 用户登录 */
      if (
        this.phoneNumber &&
        /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber) == true &&
        this.isImgCodeTrue == true
      ) {
        this.showPhoneTip = false;
        this.showCodeTip = false;
        this.showImgTip = false;
        let dataObj = {
          phone: this.phoneNumber,
          smsValidCode: this.codeNumber,
          regSource: 18,
          regDeviceType: 1,
          imgValidCode: this.imgCodeNumber,
        };
        if (localStorage.getItem("utmSource")) {
            dataObj.sourcePage = localStorage.getItem("sourcePage");
            dataObj.utmSource = localStorage.getItem("utmSource");
            dataObj.utmMedium = localStorage.getItem("utmMedium");
            dataObj.utmCampaign = localStorage.getItem("utmCampaign");
          }
        await post("/ucenter/user/LoginForCode", dataObj).then((res) => {
          if (res.data.success == true) {
            this.getUserFriend();
            this.getSignId();
            this.isLogined = true;
            this.showLoginForm = false;
          } else {
            this.veriCode = "验证码输入错误";
            this.showCodeTip = true;
          }
        });
      }
    },
    /* 发送验证码 */
    async sendCode() {
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      } else if (
        this.phoneNumber &&
        !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)
      ) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      } else {
        this.showPhoneTip = false;
      }
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
        return;
      }
      if (this.phoneNumber && /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.showPhoneTip = false;
        await post("/ucenter/API/SMSService/SendRegKeyV2?t=" + Math.random(), {
          phoneNum: this.phoneNumber,
          imageCode: this.imgCodeNumber,
           type:2
        }).then((res) => {
          if (res.data.success == false) {
            this.veriImg = "图形验证码错误";
            this.showImgTip = true;
          } else {
            this.isImgCodeTrue = true;
            this.showImgTip = false;
            this.isCounting = true;
            var time = 60;
            var countDown = setInterval(() => {
              time--;
              this.veriBtn = "重新发送" + time;
              if (time == 0) {
                this.isCounting = false;
                this.veriBtn = "获取短信验证码";
                clearInterval(countDown);
              }
            }, 1000);
          }
        });
      }
    },
    //用户账号密码登录
    async handleUserLogin() {
      if (!this.userNumber) {
        this.showUserTip = true;
        this.veriUser = "请输入用户名";
      } else if (!this.pwdNumber) {
        this.showPwdTip = true;
        this.veriPwd = "请输入密码";
      } else {
        await post("/ucenter/user/Login", {
          email: this.userNumber,
          passwd: this.pwdNumber,
        }).then((res) => {
          if (res.data.success == true) {
            this.getUserFriend();
            this.getSignId();
            this.isLogined = true;
            this.showUserLoginForm = false;
          } else {
            this.showPwdTip = true;
            this.veriPwd = "用户名或密码错误";
            this.showUserTip = false;
          }
        });
      }
    },
    handleUserLoginShow() {
      this.showLoginForm = false;
      this.showUserLoginForm = true;
    },
    handlePhoneLoginShow() {
      this.showUserLoginForm = false;
      this.showLoginForm = true;
    },
    handleShowLoginForm() {
      // this.changeImgCode();
      this.isImgCodeTrue = false;
      this.showLoginForm = false;
      this.showPhoneTip = false;
      this.showCodeTip = false;
      this.showImgTip = false;
      this.phoneNumber = "";
      this.imgCodeNumber = "";
      this.codeNumber = "";
    },
    handleImgInvite(index) {
      // console.log(
      //   "-----------this.$refs.default[index].src",
      //   this.$refs.default[index].src
      // );
      if (!(this.$refs.default[index].src.indexOf("no") > -1)) return;
      if (this.isLogined == true) {
        this.showInviteTips = true;
        var clipboard = new Clipboard(".invite-friend-img");
        clipboard.on("success", () => {
          this.showInviteTips = true;
          clipboard.destroy();
        });
        clipboard.on("error", () => {
          // 不支持复制
          this.inviteTipsContent = "该浏览器不支持自动复制,请更换浏览器重试";
          this.showInviteTips = true;
          // 释放内存
          clipboard.destroy();
        });
        this.showInviteTips = true;
        setTimeout(() => {
          this.showInviteTips = false;
        }, 2000);
      } else {
        this.showLoginForm = true;
      }
    },
    /* 点击一键邀请 */
    handleInvite() {
      gtag('event', '邀请好友 免费领码', {'event_category' : '邀友活动', 'event_label' : 'click1'});
      this.isBtnShow = false;
      if (this.isLogined == true) {
        this.showInviteTips = true;
        var clipboard = new Clipboard(".invite-friend-btn");
        clipboard.on("success", () => {
          this.showInviteTips = true;
          clipboard.destroy();
        });
        clipboard.on("error", () => {
          // 不支持复制
          this.inviteTipsContent = "该浏览器不支持自动复制,请更换浏览器重试";
          this.showInviteTips = true;
          // 释放内存
          clipboard.destroy();
        });
        this.showInviteTips = true;
        setTimeout(() => {
          this.showInviteTips = false;
        }, 2000);
      } else {
        this.showLoginForm = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  position: relative;
  overflow: hidden;
  #invite-mobile-btn {
    display: none;
  }
  .backTop {
    width: 40px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    position: fixed;
    right: 100px;
    bottom: 60px;
    border-radius: 50%;
    background-color: rgba(254, 188, 68, 0.9);
    cursor: pointer;
    line-height: 40px;
    color: #4a3a10;
    z-index: 999999;
  }
  .banner {
    display: block;
    img {
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
  .banner-mobile {
    display: none;
  }
  .loginForm {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    .loginForm-box {
      position: relative;
      width: 384px;
      height: 400px;
      background-color: #2202a1;
      border-radius: 16px;
      overflow: hidden;
      .title {
        margin-top: 48px;
        font-size: 22px;
        font-weight: bolder;
        color: #ffffff;
        text-align: center;
      }
      .desc {
        color: #d9d9d9;
        margin-top: 7px;
        font-size: 14px;
        margin-bottom: 32px;
        text-align: center;
      }
      .img-code-box {
        display: flex;
        align-items: center;
        width: 256px;
        height: 32px;
        box-sizing: border-box;
        margin: 0 auto 24px;
        input {
          width: 152px;
          height: 32px;
          border-radius: 2px;
          border: solid 1px #ffffff;
          box-sizing: border-box;
          padding-left: 10px;
          background-color: transparent;
          outline: none;
          color: #ffffff;
        }
        img {
          width: 100px;
          height: 32px;
          margin-left: 4px;
        }
        input::placeholder {
          color: #ffffff;
          opacity: 0.5;
        }
      }
      .veri-code-box {
        display: flex;
        /* align-items: center; */
        width: 256px;
        height: 32px;
        box-sizing: border-box;
        margin: 0 auto 24px;
      }
      .phone-number,
      .user-number,
      .pwd-number,
      .veri-code {
        width: 256px;
        height: 32px;
        background-color: transparent;
        margin-bottom: 24px;
        border-radius: 2px;
        outline: none;
        border: solid 1px #ffffff;
        padding-left: 10px;
        color: #fff;
        box-sizing: border-box;
      }
      .phone-number {
        margin-left: 65px;
      }
      .veri-code {
        width: 152px;
        height: 37px;
        background-color: transparent;
        border-radius: 2px;
        outline: none;
        border: solid 1px #ffffff;
        padding-left: 10px;
        color: #fff;
        box-sizing: border-box;
        &::placeholder {
          color: #ffffff;
          opacity: 0.5;
        }
        &.md {
          left: 20px;
          color: #ffffff;
        }
      }
      .pwd-number {
        width: 256px;
        height: 32px;
        background-color: transparent;
        margin-bottom: 24px;
        border-radius: 2px;
        outline: none;
        border: solid 1px #ffffff;
        padding-left: 10px;
        color: #fff;
        box-sizing: border-box;
      }
      .user-number {
        margin-left: 65px;
      }
      .pwd-number {
        margin-left: 65px;
      }
      .user-number::placeholder {
        color: #ffffff;
        opacity: 0.5;
      }
      .pwd-number::placeholder {
        color: #ffffff;
        opacity: 0.5;
      }
      .phone-number::placeholder {
        color: #ffffff;
        opacity: 0.5;
      }
      .veri-btn {
        width: 152px;
        height: 37px;
        cursor: pointer;
        background-color: transparent;
        border: solid 1px #ffb758;
        color: #ffb758;
        border-radius: 3px;
        outline: none;
        padding: 10px 6px;
        font-size: 12px;
        margin-left: 4px;
      }
      .veri-btn-counting {
        width: 152px;
        height: 37px;
        background-color: transparent;
        border: solid 1px #fff258;
        color: #ffd831;
        border-radius: 3px;
        margin-left: 4px;
        outline: none;
        font-size: 12px;
      }
      .loginForm-close {
        display: block;
        float: right;
        cursor: pointer;
        height: 18px;
        margin: 13px;
      }
      .login-btn {
        display: block;
        font-size: 14px;
        width: 256px;
        height: 33px;
        margin: 0 auto;
        margin-bottom: 21px;
        margin-top: 3px;
        color: #ffffff;
        font-weight: 700;
        letter-spacing: 1px;
        cursor: pointer;
        border: none;
        outline: none;
        background-image: linear-gradient(233deg, #de54ff 0%, #ff7e7e 100%);
        border-radius: 2px;
        box-sizing: border-box;
      }
      .user-login {
        width: 85px;
        height: 12px;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 0px;
        color: #ffffff;
        display: block;
        margin: 0 auto;
        padding-left: 14px;
      }
      .veriPhone,
      .veriCode,
      .veriUser,
      .veriPwd,
      .veriImg {
        position: absolute;
        left: 64px;
        color: red;
        font-size: 13px;
      }
      .veriPhone {
        margin-top: -25px;
      }
      .veriPwd {
        color: red;
        font-size: 13px;
        text-align: left;
        margin-top: -22px;
      }
      .veriUser {
        margin-top: -22px;
      }
      .veriCode,
      .veriPwd {
        margin-top: -20px;
        // left: 20px;
      }
      .veriImg {
        top: 224px;
      }
    }
  }
  .inviteFriendAlert {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    .inviteFriendAlert-box {
      width: 384px;
      height: 80px;
      background-color: #2202a1;
      border-radius: 16px;
      p {
        width: 288px;
        height: 18px;
        font-size: 18px;
        line-height: 18px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0 auto;
        text-align: center;
        &:first-child {
          margin-top: 15px;
        }
        &:last-child {
          margin-top: 10px;
        }
      }
    }
  }
  .wrapper-mobile {
    display: none;
  }
  .wrapper {
    width: 100%;
    height: 4100px;
    background-image: linear-gradient(181deg, #2602ab 0%, #040b46 100%);
    position: relative;

    .bg1 {
      position: absolute;
      right: -280px;
      z-index: 1;
    }
    .bg2 {
      position: absolute;
      top: 1623px;
      left: -120px;
    }
    .bg3 {
      position: absolute;
      top: 2632px;
      right: -140px;
    }
    .bg4 {
      position: absolute;
      top: 3401px;
      left: -200px;
    }
    .bg5 {
      position: absolute;
      top: 3675px;
      right: -200px;
    }
    .ball1 {
      position: absolute;
      left: -125px;
      top: 464px;
      width: 248px;
      height: 248px;
    }
    .ball2 {
      position: absolute;
      top: 1377px;
      right: -99px;
      width: 347px;
      height: 347px;
    }
    .invite-task {
      position: relative;
      > img {
        display: block;
        width: 376px;
        height: 88px;
        margin: -26px auto 0;
      }
      > div {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        > p {
          margin: 0 auto 24px;
          width: 1112px;
          height: 18px;
          font-size: 18px;
          line-height: 18px;
          letter-spacing: 0px;
          color: #ffffff;
          &:first-child {
            margin-top: 32px;
            > a {
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
    }
    .invite-friend {
      width: 1384px;
      height: 560px;
      box-sizing: border-box;
      position: relative;
      margin: 270px auto 0;
      padding-top: 79px;
      border-radius: 20px;
      background-image: linear-gradient(
        180deg,
        #5554e4 0%,
        #3c3ad9 47%,
        #4d4ce1 100%
      );
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      &-title {
        width: 750px;
        height: 138px;
        position: absolute;
        background-image: url("../images/title2.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        top: -95px;
        margin-left: 310px;
        > p {
          height: 28px;
          font-size: 28px;
          line-height: 28px;
          letter-spacing: 0px;
          color: #ffffff;
          margin: 77px auto;
          text-align: center;
        }
      }
      &-box {
        width: 992px;
        height: 170px;
        margin: 0 212px 31px 180px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .invite-friend-items {
          height: 170px;
          text-align: center;
          &:not(:last-child) {
            margin-right: 60px;
          }
          > img {
            width: 112px;
            height: 125px;
          }
          .invite-friend-phone {
            margin-top: 25px;
            height: 18px;
            font-size: 18px;
            line-height: 18px;
            letter-spacing: 0px;
            color: #ffffff;
          }
        }
      }
      &-line {
        margin-left: 111px;
        position: relative;
        .invite-tip-1,
        .invite-tip-2 {
          width: 224px;
          height: 88px;
          position: absolute;
          top: 33px;
          background-image: url("../images/note1.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .invite-tip-1 {
          left: 364px;
          > p {
            height: 20px;
            text-align: center;
            font-size: 18px;
            line-height: 20px;
            letter-spacing: 0px;
            color: #ffffff;
            &:first-child {
              margin-top: 30px;
              margin-bottom: 8px;
            }
            &:last-child {
              font-weight: 500;
              color: #fec983;
            }
          }
        }
        .invite-tip-2 {
          right: 158px;
          > p {
            height: 20px;
            text-align: center;
            font-size: 18px;
            line-height: 20px;
            letter-spacing: 0px;
            color: #ffffff;
            &:first-child {
              margin-top: 30px;
              margin-bottom: 8px;
            }
            &:last-child {
              font-weight: 500;
              color: #fec983;
            }
          }
        }
        .invite-sucess-tip-1,
        .invite-sucess-tip-2 {
          width: 232px;
          height: 64px;
          position: absolute;
          top: 33px;
          background-image: url("../images/note2.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .invite-sucess-tip-1 {
          left: 360px;
          p {
            height: 18px;
            margin-top: 30px;
            text-align: center;
            font-size: 18px;
            line-height: 18px;
            letter-spacing: 0px;
            color: #ffffff;
          }
        }
        .invite-sucess-tip-2 {
          right: 154px;
          p {
            height: 18px;
            margin-top: 30px;
            text-align: center;
            font-size: 18px;
            line-height: 18px;
            letter-spacing: 0px;
            color: #ffffff;
          }
        }
      }
      &-btn {
        width: 456px;
        height: 48px;
        margin: 138px auto 16px;
        cursor: pointer;
        background-image: linear-gradient(233deg, #de54ff 0%, #ff7e7e 100%);
        border-radius: 4px;
        p {
          height: 18px;
          text-align: center;
          font-size: 18px;
          line-height: 48px;
          letter-spacing: 0px;
          color: #ffffff;
        }
      }
      .activate-method {
        display: block;
        width: 112px;
        height: 16px;
        margin: 0 auto;
        text-decoration: underline;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
    .three-steps {
      box-sizing: border-box;
      padding-top: 96px;
      .title3 {
        width: 310px;
        height: 47px;
        display: block;
        margin: 0 auto;
      }
      .three-steps-content {
        width: 822px;
        margin: 64px auto 0;
        display: flex;
        .three-steps-item {
          img {
            width: 192px;
            height: 168px;
            margin-left: 15px;
            margin-bottom: 10px;
          }
          p {
            text-align: center;
            height: 20px;
            font-size: 18px;
            line-height: 20px;
            letter-spacing: 1px;
            color: #ffffff;
            &:last-child {
              margin-top: 9px;
            }
          }
          &:not(:last-child) {
            margin-right: 90px;
          }
        }
      }
    }
    .activity-question {
      width: 745px;
      margin: 112px auto 0;
      display: flex;
      img {
        width: 300px;
        height: 300px;
        margin-right: 52px;
      }
      .right-content {
        width: 392px;
        height: 76px;
        font-size: 28px;
        line-height: 48px;
        letter-spacing: 0px;
        color: #ffffff;
        ul {
          list-style-type: none;
          li {
            display: flex;
            margin-bottom: 24px;
            &:first-child {
              margin-top: 64px;
            }
            img {
              width: 19px;
              height: 18px;
              margin-right: 10px;
            }
            p {
              width: 234px;
              height: 18px;
              font-size: 18px;
              line-height: 18px;
              letter-spacing: 0px;
              color: #ffffff;
            }
          }
        }
      }
    }
    .advantage {
      margin-top: 96px;
      > img {
        width: 310px;
        height: 47px;
        display: block;
        margin: 0 auto;
      }
      a {
        width: 155px;
        height: 16px;
        text-decoration: underline;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        margin: 22px auto 47px;
        display: block;
      }
      .compare {
        width: 856px;
        height: 458px;
        display: block;
        margin: 0 auto;
      }
      > p {
        height: 15px;
        font-size: 14px;
        line-height: 15px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        margin-top: 24px;
      }
    }
    .activity {
      width: 992px;
      height: 1232px;
      border-radius: 8px;
      margin: 96px auto 0;
      background-color: rgba(255, 255, 255, 0.1);
      box-sizing: border-box;
      padding-top: 66px;
      &-heading {
        height: 22px;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 4px;
        color: #ffffff;
        text-align: center;
      }
      .rule {
        display: flex;
        align-items: center;
        margin-left: 108px;
        > img {
          width: 32px;
          height: 32px;
          margin-right: 28px;
        }
        .title {
          width: 96px;
          height: 20px;
          font-size: 20px;
          line-height: 20px;
          letter-spacing: 4px;
          color: #fed590;
          margin-right: 24px;
        }
        &.first {
          margin-top: 20px;
          p:last-child {
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #ffffff;
          }
        }
        &.second {
          margin-top: 28px;
          p:last-child {
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #ffffff;
          }
        }
        &.third {
          margin-top: 28px;
        }
        &.fourth {
          margin-top: 75px;
          p {
            width: 242px;
          }
        }
        &.fifth {
          margin-top: 50px;
          p {
            width: 120px;
          }
        }
      }
      .content {
        width: 713px;
        margin-left: 175px;
        &-title {
          height: 18px;
          line-height: 18px;
          margin-top: 24px;
          font-size: 14px;
          font-weight: normal;
          letter-spacing: 3px;
          color: #ffffff;
          > span {
            font-size: 18px;
            letter-spacing: 4px;
            color: #fed590;
          }
        }
        p:not(:first-child) {
          height: 24px;
          line-height: 24px;
          font-size: 14px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-bottom: 5px;
        }
        p:nth-child(2) {
          margin-top: 16px;
        }
        p:nth-child(3) {
          margin-top: 25px;
        }
      }
      .deliver {
        width: 713px;
        margin-top: 16px;
        margin-left: 175px;
        &-title {
          height: 24px;
          line-height: 26px;
          font-size: 14px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-bottom: 5px;
          > span {
            letter-spacing: 4px;
            font-size: 18px;
            color: #fed590;
          }
          &.use {
            margin-top: 28px;
          }
        }
      }
      .tips {
        width: 76px;
        height: 16px;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 3px;
        color: #ffffff;
        margin-left: 111px;
        margin-top: 20px;
        p:not(:first-child) {
          width: 713px;
          height: 60px;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-left: 64px;
        }
        p:nth-child(2) {
          margin-top: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .main {
    #invite-mobile-btn-wrap {
      width: 100%;
      height: 80px;
      background-color: rgba(56, 63, 123, 0.85);
      overflow: hidden;
      position: fixed;
      bottom: 0;
      z-index: 9998;
      #invite-mobile-btn {
        display: block;
        width: 380px;
        height: 50px;
        line-height: 50px;
        display: block;
        color: #fff;
        text-align: center;
        background-image: linear-gradient(233deg, #de54ff 0%, #ff7e7e 100%);
        border: none;
        outline: none;
        border-radius: 5px;
        font-size: 16px;
        margin: 0 auto;
        margin-top: 15px;
      }
    }
    .backTop {
      display: none;
    }
    .banner {
      display: none;
    }
    .banner-mobile {
      display: block;
      img {
        width: 100%;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
    .inviteFriendAlert {
      .inviteFriendAlert-box {
        width: 288px;
        height: 80px;
        border-radius: 16px;
        p {
          width: 176px;
          height: 18px;
          font-size: 16px;
        }
      }
    }
    .loginForm {
      .loginForm-box {
        width: 290px;
        height: 335px;
        border-radius: 8px;
        padding-bottom: 10px;
        box-sizing: border-box;
        .loginForm-close {
          width: 17px;
          height: 17px;
        }
        .title {
          width: 155px;
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          letter-spacing: 0px;
          margin: 46px auto 10px;
        }
        .loginForm-close {
          height: 12px;
        }
        .desc {
          height: 11px;
          font-size: 11px;
          line-height: 11px;
          letter-spacing: 0px;
          margin: 0 auto 10px;
        }
        .phone-number {
          width: 250px;
          height: 30px;
          border-radius: 1px;
          margin-bottom: 17px;
          margin-left: 20px;
          margin-top: 20px;
        }
        .img-code-box {
          margin: 0 auto 17px;
          input {
            width: 120px;
            height: 30px;
            border-radius: 1px;
            margin-left: 3px;
          }
          img {
            width: 120px;
            height: 30px;
            /* background-color: rgba(255, 255, 255, 0.5); */
            border-radius: 1px;
            margin-left: 10px;
          }
        }
        .veriPhone {
          margin-top: -18px;
          left: 20px;
        }
        .veriImg {
          top: 189px;
          left: 20px;
        }
        .veriUser {
          margin-top: -18px;
          left: 20px;
        }
        .veriPwd {
          margin-top: -18px;
          left: 20px;
          margin-left: 0;
        }
        .veri-code-box {
          margin-bottom: 17px;
          & + p {
            left: 20px;
          }
        }
        .veri-code {
          width: 120px;
          height: 30px;
          border-radius: 1px;
          margin-left: 3px;
        }
        .veri-btn {
          width: 120px;
          height: 30px;
          border-radius: 1px;
          margin-left: 10px;
          padding: 0;
        }
        .login-btn {
          width: 250px;
          height: 30px;
          font-size: 12px;
          margin-bottom: 10px;
        }
        .user-login {
          height: 11px;
          font-size: 11px;
          line-height: 11px;
          letter-spacing: 0px;
          margin-top: 15px;
        }
      }
    }
    #userLoginForm {
      .loginForm-box {
        height: 300px;
        .user-number {
          width: 250px;
          height: 30px;
          margin-bottom: 18px;
          margin-left: 20px;
          margin-top: 24px;
        }
        .pwd-number {
          width: 250px;
          height: 30px;
          margin-bottom: 18px;
          margin-left: 20px;
        }
      }
    }
    .wrapper {
      display: none;
    }
    .wrapper-mobile {
      overflow: hidden;
      display: block;
      width: 100%;
      height: 3540px;
      padding-top: 27px;
      background-image: linear-gradient(181deg, #2502aa 0%, #0b095b 100%);
      .invite-task {
        img {
          display: block;
          margin: 0 auto;
          width: 237px;
        }
        > div {
          p {
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            letter-spacing: 0px;
            color: #ffffff;
            margin-bottom: 5px;
            text-align: center;
          }
          p:first-child {
            margin-top: 24px;
          }
          p:nth-child(3) {
            font-size: 12px;
            letter-spacing: 0px;
            color: #d2d2d2;
            a {
              text-decoration: underline;
            }
          }
          p:nth-child(4) {
            text-align: left;
            margin: 8px auto 5px;
            width: 250px;
          }
          p:nth-child(5) {
            text-align: left;
            margin: 20px auto 0;
            width: 250px;
          }
        }
      }
      .invite-friend {
        width: 288px;
        height: 816px;
        position: relative;
        margin: 65px auto 0;
        background-image: linear-gradient(224deg, #3d3bd9 0%, #3e3cda 100%);
        border-radius: 5px;
        &-title {
          background-image: url("../images/mobile/invite-friend-bg.png");
          background-repeat: no-repeat;
          background-position: center;
          position: absolute;
          background-size: contain;
          top: -30px;
          width: 260px;
          height: 54px;
          margin-left: 15px;
          > p {
            height: 13px;
            font-size: 13px;
            line-height: 23px;
            letter-spacing: 0px;
            color: #ffffff;
            margin-top: 18px;
            text-align: center;
          }
        }
        &-box {
          display: flex;
          position: relative;
          padding-top: 28px;
          > img {
            margin: 3px 39px 0 29px;
          }
          .invite-tip-1 {
            width: 179px;
            height: 64px;
            background-image: url("../images/mobile/note1.png");
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            position: absolute;
            top: 278px;
            left: 79px;
            p {
              width: 155px;
              height: 20px;
              font-size: 14px;
              line-height: 20px;
              letter-spacing: 0px;
              color: #ffffff;
              text-align: center;
              margin-left: 20px;
              &:first-child {
                margin-top: 10px;
              }
              &:last-child {
                color: #fec983;
                margin-top: 5px;
              }
            }
          }
          .invite-tip-2 {
            width: 179px;
            height: 64px;
            background-image: url("../images/mobile/note1.png");
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            position: absolute;
            top: 615px;
            left: 79px;
            p {
              width: 155px;
              height: 20px;
              font-size: 14px;
              line-height: 20px;
              letter-spacing: 0px;
              color: #ffffff;
              text-align: center;
              margin-left: 20px;
              &:first-child {
                margin-top: 10px;
              }
              &:last-child {
                color: #fec983;
                margin-top: 5px;
              }
            }
          }
          .invite-sucess-tip-1,
          .invite-sucess-tip-2 {
            width: 180px;
            height: 50px;
            position: absolute;
            left: 79px;
            background-image: url("../images/mobile/note2.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            p {
              width: 124px;
              height: 14px;
              font-size: 14px;
              line-height: 14px;
              letter-spacing: 0px;
              color: #ffffff;
              margin-left: 35px;
              margin-top: 17px;
            }
          }
          .invite-sucess-tip-1 {
            top: 282px;
          }
          .invite-sucess-tip-2 {
            top: 620px;
          }
          .invite-friend-list {
            .invite-friend-items {
              display: flex;
              margin-bottom: 11px;
              .invite-friend-img {
                width: 60px;
                height: 66px;
                margin-right: 17px;
              }
              .invite-friend-phone {
                width: 77px;
                height: 14px;
                font-size: 14px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #ffffff;
                margin-top: 25px;
              }
              &:nth-child(3) {
                margin-bottom: 115px;
              }
            }
          }
        }
        &-btn {
          width: 232px;
          height: 32px;
          background-image: linear-gradient(233deg, #de54ff 0%, #ff7e7e 100%);
          border-radius: 4px;
          margin: 20px auto 0;
          p {
            font-size: 16px;
            line-height: 32px;
            letter-spacing: 0px;
            color: #ffffff;
            text-align: center;
          }
          + a {
            width: 84px;
            height: 12px;
            text-decoration: underline;
            font-size: 12px;
            line-height: 12px;
            letter-spacing: 0px;
            color: #ffffff;
            display: block;
            margin: 18px auto;
          }
        }
      }
      .three-steps {
        width: 100%;
        margin-top: 48px;
        > img {
          display: block;
          margin: 0 auto 36px;
        }
        &-content {
          margin: 0 auto;
          ul {
            list-style: none;
            li {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 25px;
              img {
                width: 80px;
                height: 87px;
              }
              p {
                width: 125px;
                height: 49px;
                font-size: 14px;
                line-height: 24px;
                letter-spacing: 1px;
                color: #ffffff;
                margin-top: -10px;
                margin-left: 24px;
              }
            }
          }
        }
      }
      .activity-question {
        .title {
          p {
            width: 224px;
            height: 50px;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 27px;
            letter-spacing: 0px;
            color: #ffffff;
            margin: 0 auto;
            text-align: center;
          }
          > img {
            width: 168px;
            height: 168px;
            margin: 30px auto 0;
            display: block;
          }
        }
        ul {
          margin: 31px auto 0;
          li {
            display: flex;
            justify-content: center;
            margin-bottom: 18px;
            img {
              width: 14px;
              height: 14px;
              margin-right: 10px;
            }
            p {
              width: 158px;
              height: 12px;
              font-size: 12px;
              line-height: 12px;
              letter-spacing: 0px;
              color: #ffffff;
            }
          }
        }
      }
      .advantage {
        margin-top: 49px;
        img:first-child {
          width: 229px;
          height: 34px;
          display: block;
          margin: 0 auto 41px;
        }
        .compare {
          width: 280px;
          height: 685px;
          background-image: url(../images/mobile/compare.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          margin: 0 auto;
        }
        > div {
          margin-top: 10px;
          p {
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            letter-spacing: 0px;
            color: #d2d2d2;
            text-align: center;
          }
          p:not(:first-child){
            padding-left: 10px;
          }
        }
      }
      .activity {
        width: 280px;
        height: 600px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        margin: 40px auto 0;
        padding-top: 14px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
        // &::-webkit-scrollbar-thumb{
        //   width: 10px;
        //   height: 48px;
        //   background-color: pink;
        // }
        &-heading {
          width: 77px;
          height: 16px;
          font-size: 16px;
          line-height: 16px;
          letter-spacing: 3px;
          color: #ffffff;
          margin: 0 auto;
        }
        .rule {
          display: flex;
          align-items: center;
          margin-left: 16px;
          > img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            margin-top: -2px;
          }
          .title {
            width: 68px;
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #fed590;
          }
          &.first {
            margin-top: 24px;
            + p {
              height: 14px;
              font-size: 12px;
              line-height: 14px;
              letter-spacing: 2px;
              color: #ffffff;
              margin-left: 42px;
              margin-top: 8px;
            }
          }
          &.second {
            margin-top: 19px;
            + p {
              height: 14px;
              font-size: 12px;
              line-height: 14px;
              letter-spacing: 2px;
              color: #ffffff;
              margin-left: 42px;
              margin-top: 8px;
            }
          }
          &.third {
            margin-top: 19px;
          }
          &.fourth {
            margin-top: 96px;
            p {
              width: 242px;
            }
          }
          &.fifth {
            margin-top: 60px;
            p {
              width: 120px;
            }
          }
        }
        .content {
          width: 222px;
          margin-left: 16px;
          p:not(:first-child) {
            height: 36px;
            line-height: 18px;
            font-size: 12px;
            letter-spacing: 2px;
            color: #ffffff;
            margin-bottom: 5px;
          }
          p:nth-child(2) {
            margin-top: 12px;
          }
          p:nth-child(3) {
            margin-top: 32px;
          }
          &-title {
            height: 14px;
            line-height: 14px;
            margin-top: 19px;
            font-size: 12px;
            letter-spacing: 2px;
            color: #ffffff;
            > span {
              font-size: 14px;
              letter-spacing: 3px;
              color: #fed590;
            }
            &.second {
              margin-top: 35px;
              + p {
                margin-top: -14px;
              }
            }
          }
        }
        .deliver {
          margin-top: 18px;
          margin-left: 16px;
          padding-right: 26px;
          &-title {
            height: 56px;
            line-height: 18px;
            font-size: 12px;
            letter-spacing: 2px;
            color: #ffffff;
            > span {
              letter-spacing: 3px;
              font-size: 14px;
              color: #fed590;
            }
            &.use {
              margin-top: 20px;
              + p {
                margin-top: 0px;
              }
            }
            &:nth-child(2) {
              margin-top: -18px;
            }
            &.md {
              margin-top: -16px;
            }
          }
        }
        .tips {
          width: 76px;
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-left: 16px;
          margin-top: 20px;
          padding-right: 32px;
          padding-bottom: 14px;
          p:not(:first-child) {
            width: 220px;
            height: 18px;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 2px;
            color: #ffffff;
          }
          p:nth-child(2) {
            margin-top: 20px;
          }
          p:nth-child(3) {
            margin-top: 75px;
          }
          p:last-child {
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>

